/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PROSUPPLIER", "542")
  

// 接口文档

  
    
export interface IAPI76150ResDataItemTaskReportListItem {
  
  /**  */
  date?: string;
  
  /**  */
  content?: string;
  
  /**  */
  progress?: number;
  
};
    
  
    
export interface IAPI76150ResDataItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** 任务内容 */
  taskTitle?: string;
  
  /** 任务状态 */
  status?: string;
  
  /** 任务用户 ,String */
  userList?: string[];
  
  /** 任务进度 */
  progress?: number;
  
  /** 任务汇报列表 ,TaskReportResp */
  taskReportList?: IAPI76150ResDataItemTaskReportListItem[];
  
};
    
  



export interface API76150Req {
  
    bizNo: string;
  
};



export type API76150Res = IAPI76150ResDataItem[];


// 接口函数 76150 任务计划时间表

export interface IUseGetAPI76150Return {
  /** 任务计划时间表: 接口请求状态 */
  isAPI76150Loading: boolean;
  /** 任务计划时间表: 接口请求返回数据 */
  dataAPI76150: API76150Res;
  /**  任务计划时间表: 接口数据请求方法 */
  fetchAPI76150Data: (inputs: API76150Req, config?: YWRequestConfig) => Promise<API76150Res>;
  /** 任务计划时间表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76150 = ():IUseGetAPI76150Return => {
  let isMount = true;
  const [isAPI76150Loading, setIsAPI76150Loading] = useState(false);
  const [dataAPI76150, setDataAPI76150] = useState<API76150Res>({} as API76150Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/plan/view`;

  const fetchAPI76150Data = async (inputs: API76150Req, config?: YWRequestConfig): Promise<API76150Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76150Req>) || {}) as API76150Req;
    
  
    if ( isMount ) {
      setIsAPI76150Loading(true);
    }

    try {
      
      const res: any = await Request.get<API76150Res>(`${basePath}/yoaichat-web/task/instance/plan/view/${parseParams<API76150Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI76150(res || {} as API76150Res);
        setIsAPI76150Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76150Loading(false);
      }
      return false as unknown as API76150Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76150Loading,
    dataAPI76150,
    fetchAPI76150Data,
    requestUrl,
  }
}

